<mat-spinner class="mydocs-spinner" *ngIf="loading"></mat-spinner>
<div class="mydocs-spinner-text paragraph-medium-regular" *ngIf="loading"><p>Retrieving data...</p></div>
<mat-tab-group
  #budgetSummaryTab
  dynamicHeight
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  *ngIf="!loading && noErr"
  [selectedIndex]="selectedTabIndex"
>
  <mat-tab label="Operating ({{operatingBudgetAllocations.length}})">
    <app-read-only-table
      [data]="operatingBudgetAllocations"
      [columns]="operatingColumns"
    ></app-read-only-table>
  </mat-tab>
  <mat-tab label="Capital ({{capitalBudgetAllocations.length}})">
    <app-read-only-table
      [data]="capitalBudgetAllocations"
      [columns]="capitalColumns"
    ></app-read-only-table>
  </mat-tab>
  <mat-tab label="Capital AUC ({{captialAUCBudgetAllocations.length}})">
    <app-read-only-table
      [data]="captialAUCBudgetAllocations"
      [columns]="capitalAUCColumns"
    ></app-read-only-table>
  </mat-tab>
  <mat-tab  label="Project ({{projectBudgetDataSource.data.length}})" *ngIf="permissionData$| async as permissionData">
    <app-add-reference-card [desc]="noDataMessage" *ngIf="projectBudgetDataSource.data.length < 1">
    </app-add-reference-card>
    <div class="scrollmenu">
    <table *ngIf="projectBudgetDataSource.data.length > 0" mat-table [dataSource]="projectBudgetDataSource"
      class="mat-elevation-z8 data-grid-table">
      <ng-container *ngFor="let column of projectColumns" [matColumnDef]="column.columnDef">
        <div *ngIf="column.columnDef == 'approvingPersonnel'">
          <th mat-header-cell *matHeaderCellDef>
            {{ column.header }}
          </th>
          <td mat-cell *matCellDef="let row">
            <form class="personnel-form" *ngIf="!row.isDeleted && !row.Strikethrough && row.totalAmount > 6000">
              <mat-form-field>
                <mat-select [(ngModel)]="row.personnel" (displayWith)="(displayApprovingOfficer)" name="personnel"
                  [disabled]="isReadOnly && !permissionData.ability.can('update', permissionData.formAor)"
                  (selectionChange)="onApprovalSelectionChange($event,row)">
                  <mat-option *ngFor="let personnel of row.personnelOptions" [value]="personnel">
                    {{ personnel.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
            <div class="less-6k-class" *ngIf="row.totalAmount <= 6000">-</div>
          </td>
        </div>
        <ng-container *ngIf="column.columnDef === 'projectBudget'">
          <td mat-cell *matCellDef="let row">
            <!-- Bind to innerHTML -->
            <span [innerHTML]="row.projectBudget"></span>
          </td>
        </ng-container>
    
        <!-- Data cell for 'glAccount' column -->
        <ng-container *ngIf="column.columnDef === 'glAccount'">
          <td mat-cell *matCellDef="let row">
            <!-- Bind to innerHTML -->
            <span [innerHTML]="row.glAccount"></span>
          </td>
        </ng-container>
    
        <!-- Data cell for 'itemNo' column -->
        <ng-container *ngIf="column.columnDef === 'itemNo'">
          <td mat-cell *matCellDef="let row">
            <!-- Bind to innerHTML -->
            <span [innerHTML]="row.displayPurchaseItemNumber"></span>
          </td>
        </ng-container>

        <ng-container *ngIf="column.columnDef === 'amount'">
          <td mat-cell *matCellDef="let row">
            <!-- Bind to innerHTML -->
            <span [innerHTML]="row.aorAmount"></span>
          </td>
        </ng-container>
        <div>
          <th mat-header-cell *matHeaderCellDef>
            {{ column.header }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ column.cell(row) }}
          </td>
        </div>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="projectDisplayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: projectDisplayColumns"></tr>
    </table>
    </div>
    <mat-paginator
    [ngClass]="{ 'd-none': projectBudgetAllocations.length < 1 }" 
      [length]="projectBudgetAllocations.length"
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 50]"
      showFirstLastButtons
    >
    </mat-paginator>
  </mat-tab>
</mat-tab-group>
